import { ProjectSectionHeader } from '@/components/projects'
import { Button } from '@/components/ui/button'
import { AddIcon } from '@/components/icons'
import { useAuth } from '@/hooks'
import { Permissions } from '@/lib/permissions'

interface SkillsHeaderProps {
  projectId: string
  onCreateSkill: () => void
}

export function SkillsHeader({ projectId, onCreateSkill }: SkillsHeaderProps) {
  const { hasPermission } = useAuth(projectId)

  return (
    <ProjectSectionHeader sectionName="Skills">
      {hasPermission(Permissions.Project.Skill.Create, projectId) && (
        <Button onClick={onCreateSkill}>
          <AddIcon />
          New Skill
        </Button>
      )}
    </ProjectSectionHeader>
  )
}
